import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@/components/Icon';

const STORAGE_KEY = 'cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem(STORAGE_KEY, 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[200] p-4 md:p-6">
      <div className="max-w-4xl mx-auto bg-[#0F1A14] border border-white/10 rounded-2xl px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-5 shadow-2xl">
        <div className="flex items-start gap-4 flex-1">
          <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 flex-shrink-0 mt-0.5">
            <Icon name="ri-shield-check-line" className="text-[#D4A853] text-lg" />
          </div>
          <p className="text-white/60 text-sm leading-relaxed">
            Size daha iyi bir deneyim sunmak için çerezler kullanıyoruz.{' '}
            <Link to="/cerez-politikasi" className="text-[#D4A853] hover:underline">
              Çerez Politikası
            </Link>{' '}
            ve{' '}
            <Link to="/kvkk" className="text-[#D4A853] hover:underline">
              KVKK Aydınlatma Metni
            </Link>{' '}
            hakkında bilgi alabilirsiniz.
          </p>
        </div>
        <div className="flex gap-3 flex-shrink-0">
          <button
            onClick={reject}
            className="px-5 py-2.5 rounded-full border border-white/15 text-white/50 hover:text-white hover:border-white/30 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            Reddet
          </button>
          <button
            onClick={accept}
            className="px-5 py-2.5 rounded-full bg-[#D4A853] hover:bg-[#c49840] text-[#0F1A14] text-sm font-black transition-colors cursor-pointer whitespace-nowrap"
          >
            Kabul Et
          </button>
        </div>
      </div>
    </div>
  );
}
